import { store } from "@/store";
import clientInfo from "./clientInfo.js"
import { wsEvent } from '@/main.js';

export const wsMessageHandler = (message) => {
  console.log("message",message)
  
  // Обробка ping-pong для підтримки з'єднання
  try {
    if (message.type === 'ping') {
      store.socket.send(JSON.stringify({
        type: "pong",
        timestamp: message.timestamp || new Date().toISOString()
      }));
      return;
    }
  } catch (err) {
    console.log('Ping-pong error:', err);
  }
  
  //Запитать актуальні статуси. Аля хто тут є живий - відкликніться
  try {
      if (message.action == 'getOnlineStatus') {
        store.socket.send(JSON.stringify({
            action: "setOnlineStatus",
            data:clientInfo(),
            uuid:message.uuid
        }));
      }
  } catch (err) {
    console.log(err)
  }

  //користувачі які повідомляють про себе
  try {
      if (message.action == 'setOnlineStatus') {
        wsEvent.$emit('setOnlineStatus', message);
      }
  } catch (err) {
    console.log(err)
  }

  //Коли хтось підключився або відключився
  try {
      if (message.action == 'userStatusUpdate') {
        wsEvent.$emit('userStatusUpdate');
      }
  } catch (err) {
    console.log(err)
  }
}
